import { z } from 'zod';

import {
    allowEmptyString,
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    requiredBoolean,
    requiredString,
    SYNC_UPDATE_VALIDATION_SCHEMA,
    timestamp,
} from './common';

export const createUserSettingsAddSchema = () =>
    z
        .object({
            id: requiredString,
            user_id: requiredString,
            topic: allowEmptyString,
            description: allowEmptyString,
            enabled: requiredBoolean,
            created_at: timestamp,
            updated_at: timestamp,
        })
        .strict();

export const createUserSettingsUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createUserSettingsAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.user_settings,
    );

export const createUserSettingsDeleteSchema = () => createDeleteSchema();

export const createUserSettingsSchemas = () => ({
    add: createUserSettingsAddSchema(),
    update: createUserSettingsUpdateSchema(),
    delete: createUserSettingsDeleteSchema(),
});

export const userSettingsRawRecordSchema = createUserSettingsAddSchema();
